import React from 'react';
import Layout from './src/components/Common/Layout';

import axios from 'axios';
import queryString from 'query-string';
import { setCookie, getCookie, isSEO } from './src/utils/helpers';

// Pass all props (hence the ...props) to the layout component so it has access to things like pageContext or location
const wrapPageElement = ({ element, props }) => {
    // Look for params to add cookies
    const cookies = queryString.parse(props.location.search);
    let { allid, pid, sid, campaign} = cookies;
    
    // Check if visitor is referred by organic search. Set seo allId if true
    const adobeMcRef = cookies['adobe_mc_ref']
    if (!allid && isSEO(adobeMcRef)) allid = 'seo11276000';

    if (!allid && getCookie('ehi.alliance_id')) {
        allid = getCookie('ehi.alliance_id')
    }

    const dispatchAllianceChange = () => {
        if (window) {
            window.dispatchEvent(
                new CustomEvent('allianceid.change'),
            )
        }
    }

    const defaultAllid = 'ehe12862000'
    const inactiveDefaultAllid = 'eHe22850'
    if (allid) {
        const allianceAPI = `https://www.${process.env.GATSBY_SUBDOMAIN ||
                ""}ehealthinsurance.com/ifp-api/alliance/${allid}`
        axios.get(allianceAPI, {}).then(response => {
            setCookie('ehi.alliance_id', allid, 30);
            dispatchAllianceChange();
        }).catch(
            function (error) {
                allid = inactiveDefaultAllid
                setCookie('ehi.alliance_id', inactiveDefaultAllid, 30);
                dispatchAllianceChange();
            }
          );
    } else {
        allid = defaultAllid
        setCookie('ehi.alliance_id', defaultAllid, 30);
        dispatchAllianceChange();
    }


    // If params found in url, set corresponding cookie
    if (pid) setCookie('ehi.alliance_pid', pid);
    if (sid) setCookie('ehi.alliance_sid', sid);
    if (campaign) setCookie('ehi.alliance_campaign', campaign);
    
    if (!getCookie('ehiVisitorId')) {
        axios.post(`/ifp-api/misc/ehi-visitor-id`, {}).then(response => {
            setCookie('ehiVisitorId', response.data.ehiVisitorId);
        });
    }
    
    return (
        <Layout {...props} allianceId={allid}>
            {element}
        </Layout>
    );
};

export default wrapPageElement;
